// Copyright (C) 2019 TANNER AG

import React, { useState, useContext } from "react";
import * as PropTypes from "prop-types";
import { Module } from "../module";
import { withStore } from "../../store/withstore";
import { TileButton } from "../../components/button";
import { TranslationContext } from "../../translation";
import { withStyles } from "@material-ui/core";

export const format = (value, translate) => {
	if (value === true) {
		return translate("common.yes");
	}

	if (value === false) {
		return translate("common.no");
	}

	return null;
};

const styles = {
	container: {
		position: "relative"
	},
	text: {
		display: "block",
		width: "100%",
		textAlign: "center",
		fontFamily: "MANEurope, Arial, sans-serif",
		fontSize: "14px",
		lineHeight: "22px",
		fontStyle: "normal",
		fontWeight: 300,
		color: "#303c49",
		opacity: 0.5,
		position: "absolute",
		paddingTop: "0.5rem"
	}
};

const EfficientHybridButtons = withStyles(styles)(({ value, setValue, translate, disabled, classes }) => (
	<React.Fragment>
		<div className={classes.container}>
			<div>
				<TileButton
					onClick={() => setValue(true)}
					active={value === true}
					disabled={disabled}
				>
					{format(true, translate)}
				</TileButton>
				<TileButton
					onClick={() => setValue(false)}
					active={value === false}
					disabled={disabled}
				>
					{format(false, translate)}
				</TileButton>
			</div>
			{disabled && (
				<span className={classes.text}>
					{translate("module.efficienthybrid.disabled")}
				</span>
			)}
		</div>
	</React.Fragment>
));

const EfficientHybrid = (props) => {
	const { store: { a, b }, storeAction } = props;
	const [valueA, setValueA] = useState(a.efficientHybrid);
	const [valueB, setValueB] = useState(b.efficientHybrid);
	const { translate } = useContext(TranslationContext);

	const continueEnabled = () => {
		const aEnabled = !a.bus.efficientHybrid || valueA !== null;
		const bEnabled = !b.bus.efficientHybrid || valueB !== null;
		return aEnabled && bEnabled;
	};

	return (
		<Module
			id={props.id}
			activeModule={props.activeModule}
			nextModule={props.nextId}
			onActivate={props.setActiveModule}
			final={props.final}
			label="module.efficienthybrid.title"
			title="module.efficienthybrid.query"
			valueA={format(valueA, translate)}
			valueB={format(valueB, translate)}
			continueEnabled={continueEnabled()}
			onContinue={() => storeAction.setEfficientHybrid(valueA, valueB)}
			queryA={(
				<EfficientHybridButtons
					value={valueA}
					setValue={setValueA}
					translate={translate}
					disabled={!a.bus.efficientHybrid}
				/>
			)}
			queryB={(
				<EfficientHybridButtons
					value={valueB}
					setValue={setValueB}
					translate={translate}
					disabled={!b.bus.efficientHybrid}
				/>
			)}
		/>
	);
};

EfficientHybrid.propTypes = {
	id: PropTypes.string.isRequired,
	nextId: PropTypes.string.isRequired,
	activeModule: PropTypes.string,
	setActiveModule: PropTypes.func
};

export default withStore(EfficientHybrid);



// WEBPACK FOOTER //
// ./src/tco/configuration/modules/efficienthybrid.js